module.exports = __webpack_public_path__ + "static/media/BR3.d625109b.webp";